import type { SVGProps } from 'react';

const SvgClockOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path fill={props.color} d="M13 11V7a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2z" />
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgClockOutline;
